import './ProductCard.css';

export default function ProductCard({ product }) {
  return (
    <article className="pc">
      <div className="pc__image">
        <img src={product.image} alt={product.name} loading="lazy" />
        <span className="pc__tag">{product.tag}</span>
      </div>
      <div className="pc__body">
        <h3 className="pc__name">{product.name}</h3>
        <p className="pc__desc">{product.description}</p>
      </div>
    </article>
  );
}
